<template>
	<div class="counselorBack">
		<!-- --- header -->
		<v-app-bar app>
			<div style="width:100%">
				<v-layout class="bigHeader" align-center>
					<v-spacer></v-spacer>
					<!-- 상담사명, 로그아웃  -->
					<span class="counselorid"
						>{{ $store.state.counserlorLoginData.name ? $store.state.counserlorLoginData.name : counserlorLoginData.name }}
					</span>
					<span class="counselorid ml-5">
						{{
							$store.state.counserlorLoginData.counselorid ? $store.state.counserlorLoginData.counselorid : counserlorLoginData.counselorid
						}}</span
					>

					<v-divider vertical class="mx-4 my-2 vertical_divider" />

					<v-btn icon depressed small @click="logout" class="mr-4">
						<v-icon medium>
							mdi-logout
						</v-icon></v-btn
					>
					<!-- <btn :btn="logoutbtn" btn_txt="Logout" @click="logout"></btn> -->
				</v-layout>
			</div>
		</v-app-bar>
		<v-layout justify-center align-center class="mt-12 mx-2">
			<v-btn color="primary" block class="mt-4" @click="waitings()">새로고침</v-btn>
		</v-layout>
		<v-layout justify-center align-center class="mt-2">
			<txtField :txtField="nameTxtfield" v-model="nameTxtfield.value" class="customerInfo mr-2"></txtField>
			<v-btn color="primary" height="40" class="mt-2" @click="waiting_search()">검색</v-btn>
		</v-layout>
		<v-layout class="counselorContents" wrap>
			<v-flex xs12>
				<!-- --- 왼쪽 content  -->
				<div class="counselor_content_wrap">
					<!-- viewport  -->
					<v-layout column :class="$vuetify.breakpoint.xs ? 'pre-viewport_counselor rounded' : 'pre-viewport_counselor ml-5 rounded'">
						<v-layout wrap class="mb-2">
							<div class="mt-2">
								<p class="mb-1 rightSort">
									<v-icon small color="black">mdi-square</v-icon> 지정 고객 리스트 (사진 아이콘 클릭 시 상담사 얼굴 표시)
								</p>
								<datatable
									:datatable="datatable_selectMembers"
									class="tbl-type01"
									@click_photo="click_photo"
									@check_waiting="check_waiting"
								/>
							</div>
						</v-layout>
					</v-layout>
				</div>
			</v-flex>
		</v-layout>
		<alertModal :setdialog="alertModal" :clickDeleteBtnModal="deleteAccount" />
		<alertModal :setdialog="alertModal_check" :clickDeleteBtnModal="updateWaiting" />
		<alertModal2 :setdialog="alertModal2" />
		<alertModal7 :setdialog="sendAlertModal" />
	</div>
</template>

<script>
import { alertModal, alertModal2, datatable, txtField, alertModal7 } from '@/components/index'
export default {
	components: {
		txtField,
		alertModal,
		alertModal2,
		datatable,
		alertModal7,
	},
	data() {
		return {
			nameTxtfield: {
				value: '',
				color: 'primary',
				outlined: true,
				label: '고객성명',
				placeholder: '고객성명을 검색하세요.',
			},
			searchName: '',
			datatable_selectMembers: {
				headers: [
					{ text: '고객명', value: 'name' },
					{ text: '고객번호', value: 'phone' },
					{ text: '담당자', value: 'commentTag' },
					{ text: '담당자번호', value: 'groupcode' },
					{ text: '담당자 사진', value: 'counselor_photo' },
					{ text: '완료체크', value: 'check_waiting' },
				],
				items: [],
				hidedefaultfooter: true,
				noweditting: '',
				itemPerPage: 10,
				page: 1,
				pageCount: 0,
				breakpoint: true,
			},
			// --- 로그아웃 모달 ---
			alertModal2: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
			},
			alertModal: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
				btnText: '로그아웃',
			},
			alertModal_check: {
				dialog: false,
				text: '고객님의 안내를 끝내고 완료체크 하시겠습니까?',
				btnText: '완료체크',
			},
			sendAlertModal: {
				dialog: false,
				text: '상담사 이미지',
				profile: null,
			},
			logoutbtn: {
				class: '',
				color: 'primary',
				dark: true,
			},
			sendBtn: {
				color: '#202840',
				dark: false,
				class: 'white--text',
			},
			historyBtn: {
				dark: true,
				color: '#202840',
			},
			waitNum: 0,

			draggableDisable: false,
			viewportList: [],
			inputBoxesData: [],
			groups: [],
			locationSelected: '',
			picker: {
				date: '',
				errorMessage: '',
				allowedDates: '2021-5-30',
			},
			counserlorLoginData: {
				name: '',
				seat: '',
				counselorid: '',
			},
			timeData: [],
			selectedTime: '',
			sel1: { label: '설문', value: '', errorMessage: '', hideDetail: true, items: [], outlined: true }, // 인풋박스 셀렉트 박스 옵션
			sel2: { label: '사업지', value: '', errorMessage: '', hideDetail: true, items: [], outlined: true }, // 사업지 셀렉트 박스 옵션
			sel3: { label: '', value: '', errorMessage: '', hideDetail: true, outlined: true }, // viewport 셀렉트 박스 옵션
			txt: {
				value: '',
				maxlength: '255',
				outlined: true,
				autofocus: false,
				hideDetail: false,
				errorMessage: '',
			},
			reservedaysData: {
				business: { color: 'black' },
			},
			counseringData: {},
			waitingId: '',
			custComment: '', // 고객 코멘트 v-model
			commentTxtfield: {
				height: 70,
				noresize: '',
				value: '',
				outlined: true,
				placeholder: '',
				readonly: false,
			}, // 고객 코멘트 텍스트 필드 옵션
			//히스토리 모달
			alertModal3: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
				datatable: { headers: [], items: [] },
				json_fields: {},
			},
			socket: '',
			userLists: [],
		}
	},
	created() {
		if (localStorage.getItem('counserlor') === null) {
			this.$router.push({ name: 'counselorlogin_reseve_mobile', params: { code: this.$route.params.code } })
		}

		this.counselors(localStorage.getItem('counserlor').split(',')[1])
		this.waitings()
	},
	methods: {
		waiting_search() {
			this.waitings(this.nameTxtfield.value)
		},
		updateWaiting() {
			const data = {
				id: this.waitingId,
				receiveInformation: true,
			}
			this.$store.dispatch('updateWaiting', data).then(() => {
				this.alertModal_check.dialog = false
				this.waitingId = null
				this.waitings()
			})
		},
		check_waiting(item) {
			this.alertModal_check.dialog = true
			this.waitingId = item.id
		},
		click_photo(item) {
			this.sendAlertModal.profile = item
			this.sendAlertModal.dialog = true
		},
		waitings(search) {
			let data = {
				code: this.$route.params.code,
				stat: 9,
				receiveInformation: false,
				limit: 10,
				csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
				cedate:
					this.$moment(new Date())
						.add(1, 'days')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
			}
			if (search) {
				data.name = search
			}
			this.$store.dispatch('waitings', data).then(async res => {
				for await (const data of res.data.waitings) {
					data.phone = this.formatPhoneNumber(data.phone)
					if (data.groupcode) {
						await this.$store.dispatch('users_moniter', { phoneNumber: data.groupcode }).then(async user => {
							data.counselor_photo = user[0].profile
						})
					}
				}

				this.datatable_selectMembers.items = res.data.waitings
			})
		},
		// 전화번호 형식 변환 함수
		formatPhoneNumber(phoneNumber) {
			// 문자열로 변환하고 숫자가 아닌 문자 제거
			const cleaned = phoneNumber.toString().replace(/\D/g, '')

			// 길이별 형식 변환
			if (cleaned.length === 11) {
				// 010-1234-5678 형식 (휴대폰)
				return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
			} else if (cleaned.length === 10) {
				// 02-1234-5678 형식 (서울 지역번호) 또는 031-123-4567 형식
				if (cleaned.startsWith('02')) {
					return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
				} else {
					return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
				}
			} else if (cleaned.length === 9) {
				// 02-123-4567 형식 (서울 지역번호 짧은 형식)
				if (cleaned.startsWith('02')) {
					return cleaned.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
				} else {
					return cleaned.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3')
				}
			} else if (cleaned.length === 8) {
				// 1234-5678 형식 (지역번호 없는 경우)
				return cleaned.replace(/(\d{4})(\d{4})/, '$1-$2')
			}

			// 기본적으로 원본 반환
			return phoneNumber
		},

		async viewUsers() {
			this.$store.state.loading = true
		},
		counselorSearch() {},

		sendAlertTalk() {
			this.sendAlertModal.dialog = true
		},
		userExport() {
			document.getElementById(this.alertModal3.phone).click()
		},
		counselors(counselorid) {
			const data = {
				counselorid: counselorid,
				business: this.$route.params.biz,
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('counselors', data)
				.then(res => {
					this.counserlorLoginData = res.data.counselors[0]
					this.$store.state.counserlorLoginData = res.data.counselors[0]
				})
				.catch(() => {})
		},

		setStat2() {
			const data = {
				stat: 2,
				// id: localStorage.getItem('waitingId'),
				id: this.waitingId,

				code: this.$route.params.code,
				// seat: Number(this.$store.state.counserlorLoginData.seat),
				// counselorid: this.$store.state.counserlorLoginData.counselorid
				// 	? this.$store.state.counserlorLoginData.counselorid
				// 	: localStorage.getItem('counserlor').split(',')[1],
				custlike: '미처리',
			}
			this.$store
				.dispatch('updateWaiting', data)
				.then(res => {
					// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
					// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
					// this.$socket.emit('reservation', { code: this.$route.params.code })
					this.unattendedMessage(res.data.updateWaiting.waiting)
					this.counseringData = {}
					this.radios.radioSelected = ''
					this.check1.value = false
					this.check2.value = false
					this.check3.value = false

					this.waitingNumTxtfield.value = ''
					this.custComment = '' // 코멘트 초기화
					this.$store.state.loading = false
					this.datatable.items = []
					this.selectedTag = []
					this.nameTxtfield.value = ''
					this.phoneTxtfield.value = ''
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},

		checkAgree() {
			if (this.check3.value) {
				this.check3.value = false
			}
		},
		disagree() {
			if (this.check3.value) {
				this.check1.value = false
				this.check2.value = false
			}
		},
		deleteAccount() {
			this.$router.push({ name: 'counselorlogin_reseve_mobile', params: { code: this.$route.params.code } })
			this.alertModal.dialog = false
		},

		clickDeleteBtn() {
			this.alertModal.dialog = true
		},
		logout() {
			localStorage.removeItem('counserlor')
			this.alertModal.dialog = true
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
	},
}
</script>

<style lang="scss">
.waitingDialog {
	background-color: white !important;
}
.v-data-table-header-mobile {
	th {
		width: 100% !important;
	}
}
.forHistoryBtn {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.counselorContents {
	min-height: 95vh;
	height: auto;
}
.tracking-table {
	padding: 0px 40px 20px 40px;
}
.view-port_counselor {
	.viewport-item-counselor {
		padding-top: 16px !important;
	}
	display: flex;
	flex-flow: wrap;
	.viewport-item {
		padding: 10px 5px 5px 5px !important;
		justify-content: start !important;
		align-content: start !important;
		flex-grow: 0;
	}
	.surveyName {
		font-weight: bold !important;
	}
}
.fab-counselor-icon {
	bottom: 40px !important;
}
.fab-counselor-icon-2 {
	bottom: 65px !important;
	right: 50px !important;
}
.couselorHead {
	height: 80px !important;
	padding: 12px 0px 0px 20px;
	background-color: white !important;
	border-bottom: 1px solid #ffffff;
	border-color: #ffffff !important ;
	background: no-repeat left/contain url('../../assets/images/conselor_headerx2.png');
}
.bigHeader {
	font-size: 34px;
	font-weight: bold;
	color: white;
}
.couselorMain {
	max-width: 1060px;
	// width: 100vw;
}
.divider {
	border: 1px #cbd6da solid;
}
.rightSort {
	font-size: 14px;
	font-weight: bold;
}
.smallLabel {
	margin-top: 5px;
	.v-label {
		font-size: 14px;
		font-weight: bold;
		color: #a6a6a6 !important;
	}
}
.searchInput {
	.v-input__control {
		.v-input__slot {
			min-height: 26px !important;
		}
	}
}
.customerInfo {
	width: 200px !important;
	margin-top: 8px !important;
}
.counselorid {
	font-size: 16px;
	font-weight: bold;
	color: #0168b2;
}
.customerList {
	font-size: 16px;
	font-weight: bold;
	color: #6b567b;
}
.waitNum {
	span {
		font-size: 18px !important;
	}
	font-size: 18px;
	font-weight: bold;
	color: #4d4d4d;
}
.layout {
	min-width: 0px !important;
}
.counselorBack {
	background-color: white;
}
.pre-viewport_counselor {
	padding: 0px 15px 10px 15px;
	margin-top: 8px !important;
	background-color: white;

	.viewport-item {
		.width300 {
			width: 350px;
		}
		padding: 10px 0px;
		// border-bottom: 0.5px dashed #e0e0e0;
	}
}
.customerInfo-phone {
	.v-input__control {
		.v-input__slot {
			width: 200px !important;
			.v-text-field__slot {
				label {
					top: 9px !important;
					&.v-label--active {
						top: 16px !important;
					}
				}
			}
		}
	}
}
.vertical_divider {
	border-width: 0 2px 0 0 !important;
}
.counselor_content_wrap {
	max-height: calc(100vh - 100px);
	overflow-y: auto;
}
</style>
